import { render, staticRenderFns } from "./AttachmentsViewer.vue?vue&type=template&id=33f7ab24"
import script from "./AttachmentsViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports